import { OfferingService } from "./offering";
import api from "..";

export default new OfferingService(api);
